let lang = document.documentElement.lang || 'en';
$('.select-choose__body').css('display', 'none');

let old_loader = `
<div class="loader_centered">
	<div class="dl">
		<div class="dl__container">
			<div class="dl__corner--top"></div>
			<div class="dl__corner--bottom"></div>
		</div>
		<div class="dl__square"></div>
	</div>
</div>
`;

let main_loader = `
<div class="loader_centered fireplace">
	<svg class="flameSVG" viewBox="0 0 800 600" xmlns="http://www.w3.org/2000/svg" style="flex: auto;width: 400px;height: 400px;">
		<defs>
			<rect class="flame" x="400" y="310" width="5" height="5" rx="0.5" ry="0.5" fill="#FFDD02" />
			<circle class="spark" cx="400" cy="300" r="0.05" fill="#FFDD02" />
			<filter id="shadow" x="-100%" y="-100%" width="250%" height="250%">
				<feOffset in="SourceAlpha" dx="4" dy="4" result="offsetOut"></feOffset>
				<feGaussianBlur stdDeviation="3" in="offsetOut" result="drop" />
				<feOffset dx="0" dy="0" result="offsetblur"></feOffset>
				<feFlood id="glowAlpha" flood-color="#0F1217" flood-opacity="0.42"></feFlood>
				<feComposite in2="offsetblur" operator="in"></feComposite>
				<feMerge>
					<feMergeNode />
					<feMergeNode in="SourceGraphic"></feMergeNode>
				</feMerge>
			</filter>
		</defs>
		<g class="whole">
			<g class="flameContainer" />
			<g class="sparksContainer" />
			<g class="logs" opacity="1">
				<path d="M446.68,299.63l-91.46,29.22a3,3,0,0,1-3.68-2.12L349.2,318a3,3,0,0,1,2.12-3.68l91.46-29.22a3,3,0,0,1,3.68,2.12L448.8,296A3,3,0,0,1,446.68,299.63Z" fill="#612e25" />
				<path filter="url(#shadow)" d="M349.2,296l2.34-8.69a3,3,0,0,1,3.68-2.12l91.46,29.22A3,3,0,0,1,448.8,318l-2.34,8.69a3,3,0,0,1-3.68,2.12l-91.46-29.22A3,3,0,0,1,349.2,296Z" fill="#70392f" />
			</g>
		</g>
		<rect class="hit" width="200" height="260" x="300" y="230" fill="transparent" style="cursor:pointer;">
			<title>Poke the fire!</title>
		</rect>
	</svg>
</div>
`;

function animateFire(svgElements) {
	svgElements.forEach(svg => {
		const flameContainer = svg.querySelector('.flameContainer');
		const sparksContainer = svg.querySelector('.sparksContainer');
		const flameSVG = svg.querySelector('.flameSVG');

		const flamePosXArr = [10, -10];
		const flameOffset = 0.34;
		const sparkOffset = 0.72;
		const numFlames = 50;

		gsap.registerPlugin(CustomEase);

		CustomEase.create('return', 'M0,0 C0,0 0.162,1 0.4,1 0.918,1 1,0 1,0');
		CustomEase.create(
			'sparkFlicker',
			'M0,0 C0.126,0.382 0.216,0.572 0.414,0.482 0.821,0.296 0.984,0.94 1,1',
		);
		CustomEase.create(
			'flameJump',
			'M0,0 C0.126,0.382 0.256,0.248 0.406,0.23 0.85,0.176 0.984,0.94 1,1',
		);

		gsap.set('svg', { visibility: 'visible' });
		gsap.set('.whole', {
			scale: 1.52,
			transformOrigin: '50% -500%',
		});
		gsap.set('.logs', {
			opacity: 0,
			y: 10,
		});
		gsap.set('.flameContainer', { opacity: 0 });
		gsap.set('.sparksContainer', { opacity: 0 });

		const mainTl = gsap.timeline({ paused: true });
		const flameTl = gsap.timeline({ repeat: 0 });

		function createFlames() {
			for (let i = 0; i < numFlames; i++) {
				const f = svg.querySelector('.flame').cloneNode(true);
				flameContainer.appendChild(f);

				gsap.set(f, {
					x: i % 2 ? flamePosXArr[0] : flamePosXArr[1],
					transformOrigin: '50% 50%',
					rotation: -45,
				});

				const fTl = gsap.timeline({
					repeat: -1,
					repeatDelay: (numFlames - 1) * flameOffset - 2,
				});

				fTl
					.to(f, {
						duration: 2,
						x: i % 2 ? '-=22' : '+=22',
						scale: 10,
						ease: 'return',
					})
					.to(
						f,
						{
							duration: 2,
							y: -145,
							ease: 'flameJump',
						},
						'<',
					)
					.to(
						f,
						{
							duration: 2,
							fill: '#F73B01',
							ease: 'sine.out',
						},
						'<',
					)
					.to(
						f,
						{
							duration: 2,
							opacity: 0,
							ease: 'expo.in',
						},
						'<',
					);

				flameTl.add(fTl, i * flameOffset);

				const s = svg.querySelector('.spark').cloneNode(true);
				sparksContainer.appendChild(s);

				gsap.set(s, {
					x: i % 3 ? flamePosXArr[1] : flamePosXArr[0],
					transformOrigin: '50% 50%',
				});
			}
		}
		createFlames();

		const sparkTl = gsap.timeline({ repeat: -1 });
		sparkTl
			.to('.spark', {
				duration: 2,
				x: gsap.utils.wrap(['-=25', '+=15', 0, '+=23', '-=5', '+=71', '-=54']),
				scale: function () {
					return Math.random() * 23;
				},
				ease: 'return',
				stagger: sparkOffset,
			})
			.to(
				'.spark',
				{
					duration: 3,
					y: () => -(Math.random() * 200) - 200,
					ease: 'sparkFlicker',
					stagger: sparkOffset,
				},
				'<',
			)
			.to(
				'.spark',
				{
					duration: 3,
					fill: gsap.utils.wrap(['#F36B01', '#FDBB01', '#ededed']),
					ease: 'sine.in',
					stagger: sparkOffset,
				},
				'<',
			)
			.to(
				'.spark',
				{
					duration: 3,
					opacity: 1,
					ease: 'expo.in',
					stagger: sparkOffset,
				},
				'<',
			);
		mainTl.add(flameTl, 0);
		mainTl.add(sparkTl, 0);

		gsap
			.timeline()
			.to('.logs', { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' })
			.call(
				() => {
					gsap.to('.flameContainer', { opacity: 1, duration: 0.6 });
					mainTl.play();
				},
				null,
				'+=0.5',
			)
			.to('.sparksContainer', { opacity: 1, duration: 0.6 }, '+=1');

		function pokeFire() {
			resetSparks();
			const pokeTl = gsap
				.timeline({
					onComplete: () => {
						resetSparks();
						sparkTl.play(99);
					},
				})
				.timeScale(2);

			pokeTl
				.to('.logs path', {
					duration: 0.7,
					rotation: gsap.utils.wrap([3, -3]),
					transformOrigin: gsap.utils.wrap(['2% 100%', '98% 100%']),
					ease: 'return',
					stagger: 0.02,
				})
				.to(
					flameContainer,
					{
						duration: 0.7,
						scaleY: 0.8,
						transformOrigin: '50% 100%',
						ease: 'return',
					},
					'<',
				)
				.to(
					'.spark',
					{
						duration: 3,
						x: gsap.utils.wrap([
							'-=25',
							'+=15',
							0,
							'+=23',
							'-=5',
							'+=71',
							'-=54',
						]),
						scale: () => Math.random() * 30,
						ease: 'return',
						stagger: 0.07,
					},
					'<',
				)
				.to(
					'.spark',
					{
						duration: 3,
						y: () => -(Math.random() * 200) - 200,
						ease: 'sparkFlicker',
						stagger: 0.07,
					},
					'<',
				)
				.to(
					'.spark',
					{
						duration: 3,
						fill: gsap.utils.wrap(['#F36B01', '#FDBB01']),
						ease: 'sine.in',
						stagger: 0.07,
					},
					'<',
				)
				.to(
					'.spark',
					{
						duration: 3,
						opacity: 0,
						ease: 'expo.in',
						stagger: 0.07,
					},
					'<',
				);
		}
		function resetSparks() {
			const sparks = document.querySelectorAll('.spark');
			if (sparks.length > 0) {
				gsap.to(sparks, {
					duration: 0,
					x: i => (i % 3 ? flamePosXArr[1] : flamePosXArr[0]),
					y: 0,
					opacity: 1,
					scale: 1,
				});
			}
		}

		flameSVG.addEventListener('click', pokeFire);
	});
}
function initializeFireAnimation(containerSelector) {
	if (containerSelector) {
		const container = document.querySelector(containerSelector);
		if (!container) return;

		const svgs = container.querySelectorAll('.fireplace');
		if (svgs.length > 0) {
			animateFire(svgs);
		}
	} else {
		animateFire(document.querySelectorAll('.fireplace'));
	}
}

// document.addEventListener('DOMContentLoaded', initializeFireAnimation(false));
// window.addEventListener('load', function () {
// 	const isFirstLoad = !localStorage.getItem('siteLoaded');
// 	const timeoutDuration = isFirstLoad ? 1000 : 500;

// 	setTimeout(function () {
// 		const loader = document.getElementById('loader');
// 		const wrapper = document.querySelector('.wrapper');
// 		if (loader && wrapper) {
// 			loader.classList.add('loader_hidden');
// 			setTimeout(function () {
// 				loader.style.display = 'none';
// 				wrapper.style.display = 'block';
// 				loader.remove();
// 				scrollTo(0, 5);
// 			}, 500);
// 		}
// 		if (isFirstLoad) localStorage.setItem('siteLoaded', 'true');
// 	}, timeoutDuration);
// });

function addLoader(containerSelector, timeout, styles, callback) {
	if (styles && typeof styles === 'object') {
		$(containerSelector).css(styles);
	}
	$(containerSelector).html(main_loader);

	initializeFireAnimation(containerSelector);
	if (timeout && typeof timeout === 'number') {
		setTimeout(function () {
			// $(containerSelector).empty();
			if (typeof callback === 'function') {
				callback();
			}
		}, timeout);
	} else if (typeof callback === 'function') {
		callback();
	}
}

function attachQuantityButtons() {
	let quantityContainers = document.querySelectorAll('.quantity');
	quantityContainers.forEach(container => {
		let newContainer = container.cloneNode(true);
		container.parentNode.replaceChild(newContainer, container);
	});

	let quantityButtons = document.querySelectorAll('.quantity__button');
	if (quantityButtons.length > 0) {
		for (let index = 0; index < quantityButtons.length; index++) {
			const quantityButton = quantityButtons[index];
			quantityButton.addEventListener('click', function (e) {
				let value = parseInt(
					quantityButton.closest('.quantity').querySelector('input').value,
				);
				if (quantityButton.classList.contains('quantity__button_plus')) {
					value++;
				} else {
					value = value - 1;
					if (value < 1) {
						value = 1;
					}
				}
				quantityButton.closest('.quantity').querySelector('input').value =
					value;
			});
		}
	}
}
function attachSpoller() {
	//Spollers
	spollers = document.querySelectorAll('._spoller');
	spollersGo = true;
	if (spollers.length > 0) {
		for (let index = 0; index < spollers.length; index++) {
			const spoller = spollers[index];
			spoller.addEventListener('click', function (e) {
				if (spollersGo) {
					spollersGo = false;
					if (
						spoller.classList.contains('_spoller-992') &&
						window.innerWidth > 992
					) {
						return false;
					}
					if (
						spoller.classList.contains('_spoller-768') &&
						window.innerWidth > 768
					) {
						return false;
					}
					if (spoller.closest('._spollers').classList.contains('_one')) {
						let curent_spollers = spoller
							.closest('._spollers')
							.querySelectorAll('._spoller');
						for (let i = 0; i < curent_spollers.length; i++) {
							let el = curent_spollers[i];
							if (el != spoller) {
								el.classList.remove('_active');
								_slideUp(el.nextElementSibling);
							}
						}
					}
					spoller.classList.toggle('_active');
					_slideToggle(spoller.nextElementSibling);

					setTimeout(function () {
						spollersGo = true;
					}, 500);
				}
			});
		}
	}
}
function attachPopup() {
	//Popups
	let popup_link = document.querySelectorAll('._popup-link');
	let popups = document.querySelectorAll('.popup');
	for (let index = 0; index < popup_link.length; index++) {
		const el = popup_link[index];
		el.addEventListener('click', function (e) {
			if (unlock) {
				let item = el.getAttribute('href').replace('#', '');
				let video = el.getAttribute('data-video');
				popup_open(item, video);
			}
			e.preventDefault();
		});
	}
	for (let index = 0; index < popups.length; index++) {
		const popup = popups[index];
		popup.addEventListener('click', function (e) {
			if (!e.target.closest('.popup__body')) {
				popup_close(e.target.closest('.popup'));
			}
		});
	}
	let popup_close_icon = document.querySelectorAll(
		'.popup__close,._popup-close',
	);
	if (popup_close_icon) {
		for (let index = 0; index < popup_close_icon.length; index++) {
			const el = popup_close_icon[index];
			el.addEventListener('click', function () {
				popup_close(el.closest('.popup'));
			});
		}
	}
	document.addEventListener('keydown', function (e) {
		if (e.code === 'Escape') {
			popup_close();
		}
	});
}
function attachSwiperPopup() {
	//BildSlider
	let sliders = document.querySelectorAll('._swiper');
	if (sliders) {
		for (let index = 0; index < sliders.length; index++) {
			let slider = sliders[index];
			if (!slider.classList.contains('swiper-bild')) {
				let slider_items = slider.children;
				if (slider_items) {
					for (let index = 0; index < slider_items.length; index++) {
						let el = slider_items[index];
						el.classList.add('swiper-slide');
					}
				}
				let slider_content = slider.innerHTML;
				let slider_wrapper = document.createElement('div');
				slider_wrapper.classList.add('swiper-wrapper');
				slider_wrapper.innerHTML = slider_content;
				slider.innerHTML = '';
				slider.appendChild(slider_wrapper);
				slider.classList.add('swiper-bild');

				if (slider.classList.contains('_swiper_scroll')) {
					let sliderScroll = document.createElement('div');
					sliderScroll.classList.add('swiper-scrollbar');
					slider.appendChild(sliderScroll);
				}
			}
			if (slider.classList.contains('_gallery')) {
				//slider.data('lightGallery').destroy(true);
			}
		}
		sliders_bild_callback();
	}

	let sliderScrollItems = document.querySelectorAll('._swiper_scroll');
	if (sliderScrollItems.length > 0) {
		for (let index = 0; index < sliderScrollItems.length; index++) {
			const sliderScrollItem = sliderScrollItems[index];
			const sliderScrollBar =
				sliderScrollItem.querySelector('.swiper-scrollbar');
			const sliderScroll = new Swiper(sliderScrollItem, {
				direction: 'vertical',
				slidesPerView: 'auto',
				freeMode: true,
				scrollbar: {
					el: sliderScrollBar,
					draggable: true,
					snapOnRelease: false,
				},
				mousewheel: {
					releaseOnEdges: true,
				},
			});
			sliderScroll.scrollbar.updateSize();
		}
	}

	// Initialize popup swipers for each color
	let cardPopupThumbsSliders = {};
	let cardPopupMainSliders = {};

	// Initialize popup thumbs sliders first
	document
		.querySelectorAll('.popup-card-info .thumbs-gallery-card__slider')
		.forEach(function (slider) {
			const colorId = slider.getAttribute('data-color_id');
			if (colorId) {
				cardPopupThumbsSliders[colorId] = new Swiper(slider, {
					spaceBetween: 0,
					slidesPerView: 'auto',
					watchSlidesProgress: true,
					navigation: {
						nextEl: '.popup-card-info .thumbs-gallery-card-arrow-next',
						prevEl: '.popup-card-info .thumbs-gallery-card-arrow-prev',
					},
				});
			}
		});

	// Initialize popup main sliders with thumbs connection
	document
		.querySelectorAll('.popup-card-info .main-gallery-card__slider')
		.forEach(function (slider) {
			const colorId = slider.getAttribute('data-color_id');
			if (colorId && cardPopupThumbsSliders[colorId]) {
				cardPopupMainSliders[colorId] = new Swiper(slider, {
					spaceBetween: 0,
					slidesPerView: 'auto',
					navigation: {
						nextEl: '.popup-card-info .main-gallery-card-arrow-next',
						prevEl: '.popup-card-info .main-gallery-card-arrow-prev',
					},
					thumbs: {
						swiper: cardPopupThumbsSliders[colorId],
					},
				});
			}
		});

	// Initialize Fancybox for popup galleries
	setTimeout(function () {
		const fancyboxOptions = {
			Thumbs: {
				type: 'modern',
			},
			Toolbar: {
				display: {
					left: ['prev', 'infobar', 'next'],
					middle: [
						'zoomIn',
						'zoomOut',
						'toggle1to1',
						'rotateCCW',
						'rotateCW',
						'flipX',
						'flipY',
					],
					right: ['slideshow', 'download', 'thumbs', 'close'],
				},
			},
		};

		// Find all unique popup gallery groups and bind Fancybox
		$('[data-fancybox^="popup-gallery-"]').each(function () {
			const galleryName = $(this).attr('data-fancybox');
			if (!window.boundPopupGalleries) window.boundPopupGalleries = [];
			if (window.boundPopupGalleries.indexOf(galleryName) === -1) {
				Fancybox.bind('[data-fancybox="' + galleryName + '"]', fancyboxOptions);
				window.boundPopupGalleries.push(galleryName);
			}
		});
	}, 100);
}
function attachSelect() {
	//Select
	let selects = document.getElementsByTagName('select');
	if (selects.length > 0) {
		selects_init();
	}
}

function handleSelectOption(selectClass, callback) {
	$(selectClass)
		.find('.select__options')
		.on('click', '.select__option', function () {
			var $clicked = $(this);
			var value = $clicked.data('value');

			var $select = $(this).closest(selectClass).find('select');
			var option = $select.find('option[value="' + value + '"]')[0];

			if (typeof callback === 'function') {
				callback(option);
			}
		});
}

$(document).ready(function () {
	//! Developer header detection
	if ($('.developer_header').length > 0) {
		$('.page').addClass('developer');
	}

	//! Favorites
	$(document).on('click', '.add_to_favorite', function (event) {
		event.preventDefault();
		const _self = $(this);
		const box = _self.closest('.favorite__box');
		const id = box.data('id');
		const remove = _self.data('remove');

		$.ajax({
			url: '/' + lang + '/ajax/add_to_favorite', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: { id: id },
			success: function (data) {
				$('[data-id="' + id + '"]').each(function () {
					if (remove) {
						$(this).remove();
					} else {
						if (data.action === 'add') {
							$(this).addClass('_liked');
							$(this).addClass('_active');
						} else {
							$(this).removeClass('_liked');
							$(this).removeClass('_active');
							if ($(this).hasClass('delete_favorite')) {
								// window.location.reload();
								$(this).remove();
							}
						}
					}
				});
				if (data.count > 0) {
					$('.total_items_favorites').css('display', 'flex');
				} else {
					$('.total_items_favorites').css('display', 'none');
				}
				$('.total_items_favorites').text(data.count);
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
	//! Comparison
	$(document).on('click', '.add_to_comparison', function (event) {
		event.preventDefault();
		const _self = $(this);
		const id = _self.data('id');

		$.ajax({
			url: '/' + lang + '/ajax/add_to_comparison', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: { id: id },
			success: function (data) {
				$('[data-id="' + id + '"]').each(function () {
					if (data.action === 'add') {
						$(this).addClass('_compared');
					} else {
						$(this).removeClass('_compared');
						if ($(this).hasClass('delete_comparison')) {
							window.location.reload();
						}
					}
				});
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});

	//! Tabs
	const tabs = document.querySelectorAll('._tabs-item');
	tabs.forEach(tab => {
		tab.addEventListener('click', function (event) {
			const tabType = tab.getAttribute('data-tab');
			const url = new URL(window.location.href);
			if (tab.classList.contains('_active')) {
				url.searchParams.set('tab', tabType);
			} else {
				url.searchParams.delete('tab');
			}
			window.history.pushState({}, '', url);
		});
	});

	//! Lists (catalog, search, promotions, resealed, orders)
	// The whole state lives in the URL: ?page=2&sort=3&count=1&filters[12][]=value
	if (
		$(
			'.catalog_list, .search_list, .orders__list, .promotions_list, .promotion_items_list, .resealed_items_list',
		).length
	) {
		let list_request = null;
		let list_navigated = false;

		function list_params() {
			const params = new URLSearchParams(window.location.search);
			params.delete('page');
			return params;
		}

		function list_load(params) {
			const ajax__table = $('.ajax__table').data('table');
			const query = params.toString().replace(/%5B/gi, '[').replace(/%5D/gi, ']');
			const suffix = query ? '?' + query : '';

			window.history.pushState({}, '', window.location.pathname + suffix);
			list_navigated = true;

			$('.ajax__list').css({ opacity: 0.6 });

			if (list_request) list_request.abort();
			list_request = $.ajax({
				url:
					window.location.pathname.replace(ajax__table, 'ajax_' + ajax__table) +
					suffix,
				type: 'GET',
				dataType: 'json',
				success: function (data) {
					if (data.status !== 'ok') {
						window.location.reload();
						return;
					}
					$('.ajax__list').replaceWith(data.view);
					if (data.filters !== undefined) {
						$('.ajax__filters').replaceWith(data.filters);
					}
					if (data.filters_footer !== undefined) {
						$('.ajax__footer').replaceWith(data.filters_footer);
					}
					if (data.filters_total !== undefined) {
						$('.filters__total').html(data.filters_total);
					}
					attachSpoller();
				},
				error: function (xhr, status) {
					if (status === 'abort') return;
					$('.ajax__list').css({ opacity: 1 });
					console.log(xhr);
				},
			});
		}

		function list_set_select_param(name, value) {
			const params = list_params();
			if (String(value) === '0') {
				params.delete(name);
			} else {
				params.set(name, value);
			}
			list_load(params);
		}

		window.addEventListener('popstate', function () {
			if (list_navigated) window.location.reload();
		});

		$(document).on(
			'click',
			'.pagging__arrow, .pagging__item',
			function (event) {
				// Ctrl/Shift/Cmd + click opens the real link in a new tab
				if (event.ctrlKey || event.metaKey || event.shiftKey) return;
				event.preventDefault();

				const page = parseInt($(this).attr('data-page'), 10);
				if (!page) return;

				const params = list_params();
				if (page > 1) params.set('page', page);
				list_load(params);

				window.scrollTo({
					top: 0,
					behavior: 'smooth',
				});
			},
		);

		handleSelectOption('.catalog_sort_products', function (option) {
			event.preventDefault();
			list_set_select_param('sort', option.value);
		});
		handleSelectOption('.catalog_on_page', function (option) {
			event.preventDefault();
			list_set_select_param('count', option.value);
		});

		//! Catalog filters
		if ($('.catalog_list, .search_list').length) {
			create_filter_mod();

			function list_params_without_filters() {
				const params = list_params();
				Array.from(params.keys()).forEach(function (key) {
					if (key.startsWith('filters[')) params.delete(key);
				});
				return params;
			}

			function reload_flt() {
				const params = list_params_without_filters();
				const form = $(
					'form[name="' + $('.ajax__table').data('table') + '"]',
				);
				const ranges = {};

				$.each(form.serializeArray(), function (index, field) {
					const range = field.name.match(
						/^(filters\[[^\]]+\])\[(min|max|is_max)\]$/,
					);
					if (range) {
						ranges[range[1]] = ranges[range[1]] || {};
						ranges[range[1]][range[2]] = field.value;
					} else if (field.name.startsWith('filters[')) {
						params.append(field.name, field.value);
					}
				});

				// A range left at its full width is not a filter, keep it out of the URL
				$.each(ranges, function (name, range) {
					const min = parseInt(range.min, 10);
					const max = parseInt(range.max, 10);
					if (isNaN(min) || isNaN(max)) return;

					const default_min = parseInt(
						form.find('input[name="' + name + '[min]"]').attr('data-default'),
						10,
					);
					const default_max = parseInt(
						form.find('input[name="' + name + '[max]"]').attr('data-default'),
						10,
					);
					if (min === default_min && max === default_max) return;

					params.append(name + '[min]', min);
					params.append(name + '[max]', max);
					if (range.is_max === 'true') params.append(name + '[is_max]', 'true');
				});

				list_load(params);
			}

			$(document).on('click', '.mod__remove', function (event) {
				event.preventDefault();
				const filterItem = $(this).closest('.mods-catalog__item');
				const name = filterItem.attr('data-name');
				const value = filterItem.attr('data-input-value');
				$('.checkbox__filter')
					.filter(function () {
						return this.name === name && this.value === value;
					})
					.prop('checked', false);
				filterItem.remove();
				create_filter_mod();
				reload_flt();
			});
			$(document).on('click', '.clear__filters', function (event) {
				event.preventDefault();
				// Sliders and discounts live outside the ajax blocks, so reload the page
				const query = list_params_without_filters()
					.toString()
					.replace(/%5B/gi, '[')
					.replace(/%5D/gi, ']');
				window.location.href =
					window.location.pathname + (query ? '?' + query : '');
			});

			$(document).on('change', '.checkbox__filter', function (event) {
				create_filter_mod();
				reload_flt();
			});
			$(document).on('change', '.range__filter', function (event) {
				reload_flt();
			});

			function create_filter_mod() {
				const filterContainer = $('.filter__mods');
				const clear = filterContainer.data('clear');
				filterContainer.empty();

				const checkedFilters = $('.checkbox__filter:checked');
				const filterCount = checkedFilters.length;

				const filterItems = [];
				checkedFilters.each(function (index) {
					const title = $(this).data('title');
					const value = $(this).data('value');

					const filterItem = $(`
						<span class="mods-catalog__item">
							<span class="mods-catalog__value">${title} - ${value}</span>
							<div href="" class="mods-catalog__delete mod__remove">
								<svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
									<path
										d="M10 1.50714L8.99286 0.5L5 4.49286L1.00714 0.5L0 1.50714L3.99286 5.5L0 9.49286L1.00714 10.5L5 6.50714L8.99286 10.5L10 9.49286L6.00714 5.5L10 1.50714Z"
										fill="#211E22" />
								</svg>
							</div>
						</span>
					`);
					filterItem.attr('data-name', this.name);
					filterItem.attr('data-input-value', this.value);

					filterItems.push(filterItem);
				});

				// Append the first two filter items
				filterItems.slice(0, 2).forEach(item => filterContainer.append(item));

				// Add "Show More" if there are more than 2 items
				if (filterCount > 2) {
					const showMoreItem = $(`
						<span class="mods-catalog__item _more">
							<span class="mods-catalog__value">+${filterCount - 2}</span>
						</span>
					`);
					filterContainer.append(showMoreItem);

					// Add click event for "Show More"
					showMoreItem.on('click', function () {
						filterItems.slice(2).forEach(item => filterContainer.append(item));
						$(this).remove();
						const deleteAllButton = $(`.mods-catalog__clear.clear__filters`);
						if (deleteAllButton.length) {
							deleteAllButton.detach().appendTo(filterContainer);
						}
					});
				}

				// Add "Delete All" button below the filters if any filters exist
				if (filterCount > 0) {
					filterContainer.append(
						`<a href="/" class="mods-catalog__clear _reset clear__filters">${clear}</a>`,
					);
				}

				// Update filter count display
				$('.filter_mods_count').text(filterCount).toggle(filterCount > 0);
			}
		}
	}

	//! Search
	$('#search').on(
		'keyup',
		debounce(function () {
			searchProducts();
		}, 1200),
	);
	function searchProducts() {
		let element = document.getElementById('search');
		let searchQuery = element.value.trim();
		let not_found = element.getAttribute('data-not_found');

		if (searchQuery.length >= 3) {
			addLoader('.search__products', null, {}, function () {
				$.ajax({
					url: '/' + lang + '/input_search',
					method: 'POST',
					data: {
						lang: lang,
						searchQuery: searchQuery,
					},
					success: function (response) {
						let data = JSON.parse(response);
						let productsHTML = '';
						if (data.length > 0) {
							data.forEach(product => {
								// Image

								let imageHTML = '';
								if (product.image && product.image.trim() !== '') {
									imageHTML = `<picture>
																		<source srcset="${product.image}" type="image/webp">
																		<img src="${product.image}" alt="Image">
																 </picture>`;
								}
								// List
								productsHTML += `<div style="display: flex;align-items: center;gap: 5px;">
																	<a href="/${lang}/product/${product.uri}" class="product__image" style="min-width: 80px;">
																		${imageHTML}
																	</a>
																	<a href="/${lang}/product/${product.uri}" class="result-search-header__item">
																		${product.title}
																	</a>
																</div>`;
							});
						}
						if (productsHTML === '') {
							productsHTML = `<div style="padding: 10px;">${not_found}</div>`;
						}
						// Show results
						$('.search__products').html(productsHTML);

						$(document).on('click.hideResults', function (e) {
							const search_form = $('.search-header');
							const results_div = $('.search__products');

							if (
								!search_form.is(e.target) &&
								search_form.has(e.target).length === 0
							) {
								results_div.html('');
								$(document).off('click.hideResults');
							}
						});
					},
					error: function (xhr, status, error) {
						console.error(error);
					},
				});
			});
		}
	}
	function debounce(func, delay) {
		let timeoutId;
		return function () {
			const context = this;
			const args = arguments;
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				func.apply(context, args);
			}, delay);
		};
	}

	//! Cart
	function header_cart() {
		$.ajax({
			url: '/' + lang + '/header_cart', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'html',
			data: { cart: 1 },
			success: function (data) {
				$('.header__cart').html(data);
				attachQuantityButtons();
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	}
	// Add to cart
	function resolveIsResealed($btn, $product) {
		const fromBtn = $btn.attr('data-is_resealed');
		if (fromBtn !== undefined && fromBtn !== null && fromBtn !== '') {
			return parseInt(fromBtn, 10) === 1 ? 1 : 0;
		}

		const fromProductAttr = $product.attr('data-is_resealed');
		if (
			fromProductAttr !== undefined &&
			fromProductAttr !== null &&
			fromProductAttr !== ''
		) {
			return parseInt(fromProductAttr, 10) === 1 ? 1 : 0;
		}

		const fromProductData = $product.data('is_resealed');
		if (
			fromProductData !== undefined &&
			fromProductData !== null &&
			fromProductData !== ''
		) {
			return parseInt(fromProductData, 10) === 1 ? 1 : 0;
		}

		if (new URLSearchParams(window.location.search).get('resealed')) {
			return 1;
		}

		if ($('.resealed_items_list').length) {
			return 1;
		}

		return 0;
	}

	$(document).on('click', '.add_to_cart', function (e) {
		e.preventDefault();
		const _self = $(this);
		let product = _self.closest('.product__box');
		let id = product.data('id');
		let qty = product.find('.quantity__input input').val();
		let max_qty_error = product.data('max_qty_error');

		let color_id = _self.attr('data-color_id');
		let dimension_id = _self.attr('data-dimension_id');
		let modification_id = _self.attr('data-modification_id');
		let is_resealed = resolveIsResealed(_self, product);

		// Update product name in popup
		let title = product.find('.product__title').text();
		let code = product.find('.product__code').text();
		let productAddTemplate = $('.product_template_name').data('template');
		let productAdd = productAddTemplate.replace(/{n}/g, title);
		$('.product_template_name').text(productAdd);
		$('.product_template_code').text(code);

		// Update product image in popup
		let image = product.attr('data-image');
		let imageHTML = '';
		if (image) {
			imageHTML = `<picture>
										<source srcset="${image}" type="image/webp">
										<img src="${image}" alt="${title}">
									</picture>`;
		}
		$('.product_template_image').html(imageHTML);

		$.ajax({
			url: '/cart/add', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: {
				lang: lang,
				product_id: id,
				quantity: qty,
				color_id: color_id,
				dimension_id: dimension_id,
				modification_id: modification_id,
				image: image,
				is_resealed: is_resealed,
			},
			success: function (data) {
				console.log('data: ', data);

				if (data.total_items > 0) {
					$('.total_items_cart').css('display', 'flex');
				} else {
					$('.total_items_cart').css('display', 'none');
				}
				$('.total_items_cart').html(data.total_items);
				header_cart();

				if (data.status == 'max_qty') {
					let max_qty_alert = max_qty_error
						.replace(/{title}/g, title)
						.replace(/{max_qty}/g, data.max_color_qty);
					alert(max_qty_alert);
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
	// Remove from cart
	$(document).on('click', '.remove_from_cart', function (e) {
		e.preventDefault();
		const _self = $(this);
		let reload = _self.data('reload');
		let row_id = _self.data('row_id');

		// Confirm
		let confirmation = _self.data('confirmation');
		let confirmed = confirm(confirmation);
		if (!confirmed) return;

		$.ajax({
			url: '/cart/delete', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: { row_id: row_id },
			success: function (data) {
				if (data.status == 'ok') {
					if (reload) {
						location.reload();
					} else {
						if (data.total_items > 0) {
							$('.total_items_cart').css('display', 'flex');
						} else {
							$('.total_items_cart').css('display', 'none');
						}
						$('.total_items_cart').html(data.total_items);
						header_cart();
					}
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
	// Update quantity
	$(document).on('click', '.update_item_qty', function (e) {
		e.preventDefault();
		const _self = $(this);
		let product = _self.closest('.product__box');
		let input = product.find('.quantity__input input');
		let row_id = input.data('row_id');
		let qty = input.val();

		let free = $('.delivery__total').data('free');
		let currency = $('.delivery__total').data('currency');
		let max_qty_error = input.data('max_qty_error');

		$.ajax({
			url: '/cart/update', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: {
				row_id: row_id,
				quantity: qty,
			},
			success: function (data) {
				if (data.status == 'ok') {
					if (data.total_items > 0) {
						$('.total_items_cart').css('display', 'flex');
					} else {
						$('.total_items_cart').css('display', 'none');
					}
					$('.total_items_cart').html(data.total_items);

					if (!product.hasClass('header_cart')) {
						header_cart();
						product.find('.item__total span').html(data.item_total);
						$('.products__total span').html(data.products_total);
						$('.discount__total span').html(data.discount_price);
						$('.cart__total span').html(data.cart_total);

						if (data.progress >= 100) {
							$('.delivery__total').html(free);
							$('.delivery__progress').css('width', data.progress + '%');
						} else {
							$('.delivery__total').html(data.delivery_price + ' ' + currency);
							$('.delivery__progress').css('width', data.progress + '%');
						}
					} else {
						$('.header_cart_total span').html(data.cart_total);

						if (data.progress >= 100) {
							$('.delivery__total').html(free);
						} else {
							$('.delivery__total').html(data.delivery_price + ' ' + currency);
						}
					}
				} else if (data.status == 'max_qty') {
					product.find('.quantity__input input').val(data.item_qty);
					let product_title = product
						.find('.product-header-cart__name')
						.text()
						.trim();
					let max_qty_alert = max_qty_error
						.replace(/{title}/g, product_title)
						.replace(/{max_qty}/g, data.max_color_qty);
					alert(max_qty_alert);
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});

	//! Coupon
	$(document).on('click', '.add__coupon', function (e) {
		e.preventDefault();
		const _self = $(this);
		let coupon = _self.closest('.coupon__box').find('input[name=coupon]');
		let coupon_value = coupon.val();
		let title = _self.closest('.coupon__box').data('title');
		let currency = _self.closest('.coupon__box').data('currency');

		$.ajax({
			url: '/' + lang + '/ajax/add_coupon', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: {
				coupon: coupon_value,
			},
			success: function (data) {
				console.log('data: ', data);
				if (data.status == 'ok') {
					let coupon_item = $('.sidebar__second').find('.__coupon');

					if (coupon_item.length) {
						coupon_item
							.find('.sidebar-cart__value')
							.text(data.coupon.price + ' ' + currency);
					} else {
						$('.sidebar__second').append(
							`<li class="sidebar-cart__item __coupon">
								<span class="sidebar-cart__name">${title}</span>
								<span class="sidebar-cart__value">${data.coupon.price} ${currency}</span>
							</li>`,
						);
					}

					$('.cart__total span').html(data.cart_total);
					$('.coupon__info').css('color', '#19a630');
				} else {
					coupon.css('border-color', '#f00');
					$('.coupon__info').css('color', '#f00');
				}
				$('.coupon__info').html(data.message);
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});

	//! Product
	function getColorPriceData($input) {
		const parsePrice = value => {
			if (value === undefined || value === null || value === '') return 0;
			return parseFloat(String(value).replace(/\s/g, '')) || 0;
		};

		return {
			calc_price: parsePrice($input.attr('data-price')),
			calc_old_price: parsePrice($input.attr('data-old_price')),
			new_price: $input.attr('data-new_price') || '',
			new_old_price: $input.attr('data-new_old_price') || '',
			currency: $input.attr('data-currency') || '',
		};
	}

	function handleColorSelection(colorElement) {
		const _self = $(colorElement);
		let product = _self.closest('.product__box');
		let color_id = _self.data('color_id');
		let image_src = _self.val();

		console.log('self: ', _self);

		let new_qty = _self.data('new_qty');
		let qty_class = product.find('.product__qty').data('class');
		let new_code = _self.data('new_code');

		// Update URL hash with color_id only if not triggered by hash change
		if (color_id && !window.isUpdatingFromHash) {
			window.location.hash = 'color_' + color_id;
		}

		// Update product image and name/title URLs with color_id hash
		if (color_id) {
			// Update product image URL
			const productImage = product.find('.product__image');
			if (productImage.length) {
				let currentUrl = productImage.attr('href') || window.location.href;
				if (currentUrl.startsWith('/'))
					currentUrl = window.location.origin + currentUrl;
				let url = new URL(currentUrl);
				url.hash = 'color_' + color_id;
				productImage.attr('href', url.toString());
			}

			// Update product title URL
			const productTitle = product.find('.product__title');
			if (productTitle.length) {
				let currentUrl = productTitle.attr('href') || window.location.href;
				if (currentUrl.startsWith('/'))
					currentUrl = window.location.origin + currentUrl;
				let url = new URL(currentUrl);
				url.hash = 'color_' + color_id;
				productTitle.attr('href', url.toString());
			}
		}

		// Change image for product card
		product.find('.product__image picture img').attr('src', image_src);
		product.find('.product__image picture source').attr('srcset', image_src);

		if (_self.hasClass('main_product')) {
			// Hide all slider containers and show only the selected color's sliders
			$('.main-gallery-card__slider, .thumbs-gallery-card__slider').hide();
			$(
				'.color-slider-' +
					color_id +
					', .color-thumbs-' +
					color_id +
					', .popup-color-slider-' +
					color_id +
					', .popup-color-thumbs-' +
					color_id,
			).show();

			// Hide all arrows for all color groups
			$('.main-gallery-card__arrow, .thumbs-gallery-card__arrow').hide();

			// Show only arrows for the selected color group
			$(
				'.main-gallery-card-arrow-prev-' +
					color_id +
					', .main-gallery-card-arrow-next-' +
					color_id +
					', .thumbs-gallery-card-arrow-prev-' +
					color_id +
					', .thumbs-gallery-card-arrow-next-' +
					color_id,
			).css('display', 'flex');

			// Add image src and color_id for cart button
			product.attr('data-image', _self.val());
			const isResealed = resolveIsResealed(
				$('.body-card__actions .add_to_cart'),
				product,
			);
			$('.body-card__actions')
				.find('.add_to_cart')
				.attr('data-color_id', _self.data('color_id'))
				.attr('data-is_resealed', isResealed);
			$('.body-card__credit')
				.find('.get_credit')
				.attr('data-color_id', _self.data('color_id'));

			// Change available dimensions
			let firstEnabledOption = null;
			let hasDimensions = false;

			product.find('.product__color_dimension').each(function () {
				const $item = $(this);
				const $radioInput = $item.find('input[type="radio"]');
				if ($item.data('color_id') == color_id) {
					// $item.css('opacity', '1');
					$item.css('display', 'block');
					$item.css('pointer-events', 'auto');
					$radioInput.prop('disabled', false).addClass('dimension__input');
					if (!firstEnabledOption) firstEnabledOption = $radioInput;
					hasDimensions = true;
				} else {
					// $item.css('opacity', '0.5');
					$item.css('display', 'none');
					$item.css('pointer-events', 'none');
					$radioInput.prop('disabled', true).removeClass('dimension__input');
				}
			});

			// Hide or show dimension selector based on whether color has dimensions
			const dimensionSelector = product.find(
				'.body-card__select.select-body-card',
			);
			if (hasDimensions) {
				dimensionSelector.show();
			} else {
				dimensionSelector.hide();
			}

			// Trigger click on first enabled dimension
			if (firstEnabledOption) {
				firstEnabledOption.prop('checked', true);
				// Trigger click with a flag to indicate it's programmatic
				firstEnabledOption.trigger('click', [true]);
			}

			const { calc_price, calc_old_price, new_price, new_old_price, currency } =
				getColorPriceData(_self);

			let price_html = '';
			let discount = '';
			let discount_styles = 'display: none;';

			if (calc_old_price > calc_price && calc_price > 0) {
				price_html = `<span class="_now">${new_price} ${currency}</span>
										<span class="_old">${new_old_price} ${currency}</span>`;
				discount = Math.round(
					((calc_old_price - calc_price) / calc_old_price) * 100,
				);
				discount = '-' + discount + '%';
				discount_styles = 'background-color: #F26241;';
			} else {
				price_html = `<span>${new_price} ${currency}</span>`;
			}

			product.find('.product__price').html(price_html);
			product.find('.product__discount').html(discount);
			product.find('.product__discount').attr('style', discount_styles);
			$(document)
				.find('.product__discount-image')
				.attr('style', discount_styles);

			if (!new_qty) {
				$('.add_to_cart').addClass('_disabled').prop('disabled', true);
			} else {
				$('.add_to_cart').removeClass('_disabled').prop('disabled', false);
			}

			product.find('.product__code').html(new_code);
			$.ajax({
				url: '/' + lang + '/ajax/update_qty', // путь к обработчику
				type: 'POST', // метод отправки,
				dataType: 'json',
				data: {
					new_qty: new_qty,
					qty_class: qty_class,
				},
				success: function (data) {
					console.log('data: ', data);
					if (data.status == 'ok') {
						product.find('.product__qty').html(data.view);
					}
				},
				error: function (data) {
					console.log(data); // выводим ошибку в консоль
				},
			});
		} else {
			const { calc_price, calc_old_price, new_price, new_old_price, currency } =
				getColorPriceData(_self);

			let price_html = '';
			let discount = '';
			let discount_styles = 'display: none;';

			if (calc_old_price > calc_price && calc_price > 0) {
				price_html = `<span class="_now">${new_price} ${currency}</span>
										<span class="_old">${new_old_price} ${currency}</span>`;
				discount = Math.round(
					((calc_old_price - calc_price) / calc_old_price) * 100,
				);
				discount = '-' + discount + '%';
				discount_styles = 'background-color: #F26241;';
			} else {
				price_html = `<span>${new_price} ${currency}</span>`;
			}
			product.find('.product__price').html(price_html);
			product.find('.product__discount').html(discount);
			product.find('.product__discount').attr('style', discount_styles);
			$(document)
				.find('.product__discount-image')
				.attr('style', discount_styles);

			let new_qty = _self.data('new_qty');
			let qty_class = product.find('.product__qty').data('class');

			$.ajax({
				url: '/' + lang + '/ajax/update_qty', // путь к обработчику
				type: 'POST', // метод отправки,
				dataType: 'json',
				data: {
					new_qty: new_qty,
					qty_class: qty_class,
				},
				success: function (data) {
					console.log('data: ', data);
					if (data.status == 'ok') {
						product.find('.product__qty').html(data.view);
					}
				},
				error: function (data) {
					console.log(data); // выводим ошибку в консоль
				},
			});
		}
	}
	$(document).on('mouseenter', '.colorpicker__item', function (e) {
		const _self = $(this);
		const colorInput = _self.find('.product__color');
		if (colorInput.hasClass('main_product')) return;

		// Check the radio input to show this color as selected
		colorInput.prop('checked', true);

		if (_self.data('hoverTimeout')) {
			clearTimeout(_self.data('hoverTimeout'));
		}

		const timeout = setTimeout(function () {
			handleColorSelection(colorInput);
		}, 200);

		_self.data('hoverTimeout', timeout);
	});
	$(document).on('mouseleave', '.colorpicker__item', function (e) {
		const _self = $(this);
		const colorInput = _self.find('.product__color');
		if (colorInput.hasClass('main_product')) return;

		if (_self.data('hoverTimeout')) {
			clearTimeout(_self.data('hoverTimeout'));
			_self.removeData('hoverTimeout');
		}
	});

	$(document).on('click', '.product__color', function (e) {
		const parentItem = $(this).closest('.colorpicker__item');
		if (parentItem.data('hoverTimeout')) {
			clearTimeout(parentItem.data('hoverTimeout'));
			parentItem.removeData('hoverTimeout');
		}

		handleColorSelection(this);
	});
	$(document).on(
		'click',
		'.product__color_dimension',
		function (e, isProgrammatic) {
			const _self = $(this);
			let product = _self.closest('.product__box');
			let input = _self.find('input[type="radio"]');
			let new_dimension_id = $(this).data('dimension_id');
			// let new_price = $(this).data('price');
			// let new_old_price = $(this).data('old_price');
			// let new_qty = $(this).data('new_qty');
			// let qty_class = product.find('.product__qty').data('class');

			if (input.prop('disabled') || _self.css('pointer-events') === 'none') {
				e.preventDefault();
				e.stopPropagation();
				return false;
			}

			// Don't redirect if this is a programmatic click (from color selection)
			if (isProgrammatic) {
				return;
			}

			let url = _self.data('url');
			window.location.href = url;

			// Add dimension_id and price for cart button
			product.find('.add_to_cart').attr('data-dimension_id', new_dimension_id);
			product.find('.get_credit').attr('data-dimension_id', new_dimension_id);

			// let discount = '';
			// let discount_styles = 'display: none;';
			// let price_html = '';
			// let parsed_price = parseFloat(new_price.replace(/[^0-9.]/g, ''));
			// let parsed_old_price = parseFloat(new_old_price.replace(/[^0-9.]/g, ''));
			// if (parsed_old_price && parsed_old_price > parsed_price) {
			// 	price_html = `<span class="_now">${new_price}</span>
			// 								<span class="_old">${new_old_price}</span>`;
			// 	discount = Math.round(
			// 		((parsed_old_price - parsed_price) / parsed_old_price) * 100
			// 	);
			// 	discount = '-' + discount + '%';
			// 	discount_styles = 'background-color: #F26241;';
			// } else {
			// 	price_html = `<span>${new_price}</span>`;
			// }
			// product.find('.product__price').html(price_html);
			// product.find('.product__discount').html(discount);
			// product.find('.product__discount').attr('style', discount_styles);
			// $(document).find('.product__discount-image').attr('style', discount_styles);

			// // Change cart button availability
			// if (!new_qty) {
			// 	$('.add_to_cart').addClass('_disabled').prop('disabled', true);
			// } else {
			// 	$('.add_to_cart').removeClass('_disabled').prop('disabled', false);
			// }

			// Close select
			let select = _self.closest('.select-choose');
			if (select.find('.select-choose__head').hasClass('_active')) {
				select.find('.select-choose__head').removeClass('_active');
				select.find('.select-choose__body').css('display', 'none');
			}

			// // Update quantity
			// $.ajax({
			// 	url: '/' + lang + '/ajax/update_qty', // путь к обработчику
			// 	type: 'POST', // метод отправки,
			// 	dataType: 'json',
			// 	data: {
			// 		new_qty: new_qty,
			// 		qty_class: qty_class,
			// 	},
			// 	success: function (data) {
			// 		console.log('data: ', data);
			// 		if (data.status == 'ok') {
			// 			product.find('.product__qty').html(data.view);
			// 		}
			// 	},
			// 	error: function (data) {
			// 		console.log(data); // выводим ошибку в консоль
			// 	},
			// });
		},
	);
	$(document).on('click', '.get__product', function (e) {
		e.preventDefault();
		const _self = $(this);
		let product = _self.closest('.product__box');
		let id = product.data('id');
		let color_id = product.find('.product__color:checked').data('color_id');
		let is_resealed = resolveIsResealed(_self, product);

		addLoader('.custom__loader', 5000, {}, function () {
			$.ajax({
				url: '/' + lang + '/ajax/get_product', // путь к обработчику
				type: 'POST', // метод отправки,
				dataType: 'json',
				data: { id: id, color_id: color_id, is_resealed: is_resealed }, // pass color_id
				success: function (data) {
					console.log('data: ', data);
					if (data.status == 'ok') {
						$('.product__info').remove();
						$('.wrapper').append(data.view);
						attachPopup();
						attachSwiperPopup();
						// attachSelect();
						attachQuantityButtons();
						attachSpoller();

						// Trigger click on the selected color if it exists
						if (color_id) {
							setTimeout(function () {
								$(
									'.popup-card-info .product__color[data-color_id="' +
										color_id +
										'"]',
								).trigger('click');
							}, 100);
						}

						$('.select-choose__body').css('display', 'none');
					}
				},
				error: function (data) {
					console.log(data); // выводим ошибку в консоль
				},
			});
		});
	});

	//! Gallery
	$(document).on('click', '.gallery__popup', function (e) {
		const _self = $(this);
		let title = _self.data('title');
		let iframe = _self.data('iframe');

		$('.gallery__title').html(title);
		$('.gallery__iframe iframe').attr('src', iframe);
	});

	//! Update Entity API
	$(document).on(
		'change',
		'.update_entity_api',
		debounce(function (e) {
			const _self = $(this);
			let company_id = _self.val();

			$.ajax({
				url: '/' + lang + '/ajax/update_entity_api', // путь к обработчику
				type: 'POST', // метод отправки,
				dataType: 'json',
				data: { company_id: company_id },
				success: function (data) {
					console.log('data: ', data);
					if (data.status == 'success') {
						const fieldMapping = {
							company_name: 'input[name="order_entity[company_name]"]',
							company_code: 'input[name="order_entity[company_code]"]',
							bank: 'input[name="order_entity[bank]"]',
							iban: 'input[name="order_entity[iban]"]',
							region: 'input[name="order_entity[region]"]',
							city: 'input[name="order_entity[city]"]',
							address: 'input[name="order_entity[address]"]',
						};

						Object.keys(fieldMapping).forEach(key => {
							if (data.data[key]) {
								$(fieldMapping[key]).val(data.data[key]);
							}
						});
					}
				},
				error: function (data) {
					console.log(data); // выводим ошибку в консоль
				},
			});
		}, 500),
	);
});
